import React from 'react';
import styled from 'styled-components';
import { IStyled } from '../../../../styles/types';
import { useAppDispatch } from '../../../../redux/hooks';
import { ModalSliceType, openModal } from '../../../../redux/slices/modal';
import { ITileFieldsFragment } from '../../../../utils/apollo/graphqlSchema';
import { SvgIcon } from '../../../../components/Icon';

interface IProps extends IStyled {
  tile: ITileFieldsFragment;
}

const Container = styled.div`
  flex: 0 0 auto;
  display: flex;
  column-gap: 4px;
`;

const TileActions = ({ tile, className }: IProps) => {
  const dispatch = useAppDispatch();

  const handleEditClick = (e: React.MouseEvent) => {
    e.preventDefault();
    dispatch(openModal({ type: ModalSliceType.UpsertTile, data: tile }));
  };

  const handleDeleteClick = (e: React.MouseEvent) => {
    e.preventDefault();
    dispatch(openModal({ type: ModalSliceType.DeleteTile, data: tile.id }));
  };

  return (
    <Container className={className}>
      <SvgIcon
        name="pencil"
        width={24}
        height={24}
        isHoverable={true}
        onClick={handleEditClick}
      />
      <SvgIcon
        name="trash"
        width={24}
        height={24}
        isHoverable={true}
        onClick={handleDeleteClick}
      />
    </Container>
  );
};

export default TileActions;
